var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPump(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 16,
    viewBox: "0 0 41 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hinava_random_uuid_23391420201564333820245313860174038028)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.65178 10.8196V8.06478H9.06265C9.99047 8.06478 10.7158 7.84319 11.2387 7.4C11.7648 6.95681 12.0279 6.35261 12.0279 5.58739C12.0279 5.08362 11.9083 4.63406 11.6692 4.2387C11.43 3.84333 11.0873 3.53884 10.6409 3.32522C10.1945 3.10841 9.67801 3 9.09134 3H6.04004V10.8196H7.65178ZM9.09134 6.75913H7.65178V4.30565H9.1296C9.52497 4.31203 9.83584 4.43319 10.0622 4.66913C10.2886 4.90507 10.4018 5.21435 10.4018 5.59696C10.4018 5.97 10.2902 6.25696 10.067 6.45783C9.84381 6.6587 9.51859 6.75913 9.09134 6.75913Z",
    fill: "url(#hinava_random_uuid_68701676848376544074044137873651336765)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9293 10.9248C15.6053 10.9248 16.1345 10.692 16.5171 10.2265L16.5602 10.8196H18.0237V5.0087H16.4645V9.12174C16.2669 9.48841 15.905 9.67174 15.3789 9.67174C14.8273 9.67174 14.5515 9.36884 14.5515 8.76304V5.0087H13.0019V8.81565C13.0083 9.50754 13.1757 10.032 13.5041 10.3891C13.8325 10.7462 14.3076 10.9248 14.9293 10.9248Z",
    fill: "url(#hinava_random_uuid_58928628472084040224784975706981763157)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6494 5.0087L20.6972 5.65913C21.1085 5.15217 21.6649 4.8987 22.3663 4.8987C23.1156 4.8987 23.6305 5.19522 23.9111 5.78826C24.3192 5.19522 24.9011 4.8987 25.6568 4.8987C26.2849 4.8987 26.7536 5.08362 27.0629 5.45348C27.3721 5.82014 27.5268 6.37174 27.5268 7.10826V10.8196H25.9676V7.11304C25.9676 6.78464 25.9023 6.54391 25.7715 6.39087C25.644 6.23783 25.4176 6.1613 25.0924 6.1613C24.6269 6.1613 24.3049 6.38449 24.1263 6.83087L24.1311 10.8196H22.5768V7.11783C22.5768 6.78304 22.5098 6.54072 22.3759 6.39087C22.2452 6.23783 22.0204 6.1613 21.7015 6.1613C21.2616 6.1613 20.9427 6.34464 20.745 6.7113V10.8196H19.1955V5.0087H20.6494Z",
    fill: "url(#hinava_random_uuid_110536974848800371064169314750911470634)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.333 10.1165C33.7412 9.57768 33.9452 8.86188 33.9452 7.96913V7.88783C33.9452 6.95681 33.7459 6.22667 33.3474 5.69739C32.9488 5.16493 32.3925 4.8987 31.6783 4.8987C31.0725 4.8987 30.5814 5.12507 30.2052 5.57783L30.1526 5.0087H28.713V13.053H30.2626V10.3126C30.6261 10.7207 31.1012 10.9248 31.6878 10.9248C32.3797 10.9248 32.9281 10.6554 33.333 10.1165ZM32.1039 6.6013C32.2952 6.89464 32.3909 7.31232 32.3909 7.85435C32.3909 9.06913 32.0194 9.67652 31.2765 9.67652C30.7919 9.67652 30.4539 9.48522 30.2626 9.10261V6.72087C30.4443 6.34783 30.7791 6.1613 31.267 6.1613C31.6336 6.1613 31.9126 6.30797 32.1039 6.6013Z",
    fill: "url(#hinava_random_uuid_324946216084942554521615961956929913341)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0400391 3.5C0.0400391 1.567 1.60704 0 3.54004 0H36.45C38.383 0 39.95 1.567 39.95 3.5V12.5C39.95 14.433 38.383 16 36.45 16H3.54004C1.60704 16 0.0400391 14.433 0.0400391 12.5V3.5ZM3.54004 1H36.45C37.8308 1 38.95 2.11929 38.95 3.5V12.5C38.95 13.8807 37.8307 15 36.45 15H3.54004C2.15933 15 1.04004 13.8807 1.04004 12.5V3.5C1.04004 2.11929 2.15933 1 3.54004 1Z",
    fill: "url(#hinava_random_uuid_251952292719854889148823934628596835184)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_68701676848376544074044137873651336765",
    x1: 24.6227,
    y1: 5.25536,
    x2: 24.6227,
    y2: 14.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_58928628472084040224784975706981763157",
    x1: 24.6227,
    y1: 5.25536,
    x2: 24.6227,
    y2: 14.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_110536974848800371064169314750911470634",
    x1: 24.6227,
    y1: 5.25536,
    x2: 24.6227,
    y2: 14.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_324946216084942554521615961956929913341",
    x1: 24.6227,
    y1: 5.25536,
    x2: 24.6227,
    y2: 14.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_251952292719854889148823934628596835184",
    x1: 24.6227,
    y1: 5.25536,
    x2: 24.6227,
    y2: 14.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hinava_random_uuid_23391420201564333820245313860174038028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.54,
    height: 16,
    fill: "white",
    transform: "translate(0.0400391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPump);
export default __webpack_public_path__ + "static/media/pump.b1dd81f7347a459c01b7ad7458b33327.svg";
export { ForwardRef as ReactComponent };